import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { sentimentTrackerOnboardingActions } from "stores/SentimentTracker/sentimentTrackerOnboarding/sentimentTrackerOnboardingAction";
import { getKycCrossProductProps } from "helper/kycDocumentUpload";
import { config } from "config";

const mapStateToProps = (state) => {
    return {
        currentStage: state.sentimentTracker.sentimentTrackerOnboarding.currentStage,
        panNumber: state.sentimentTracker.sentimentTrackerOnboarding.panNumber,
        dateOfBirth: state.sentimentTracker.sentimentTrackerOnboarding.dateOfBirth,
        isPanUploaded: state.sentimentTracker.sentimentTrackerOnboarding.isPanUploaded,
        isAadhaarFrontUploaded:
            state.sentimentTracker.sentimentTrackerOnboarding.isAadhaarFrontUploaded,
        isAadhaarBackUploaded:
            state.sentimentTracker.sentimentTrackerOnboarding.isAadhaarBackUploaded,
        panVerification:
            state.sentimentTracker.sentimentTrackerOnboarding.panVerification,
        aadharFrontVerification:
            state.sentimentTracker.sentimentTrackerOnboarding.aadharFrontVerification,
        aadharBackVerification:
            state.sentimentTracker.sentimentTrackerOnboarding.aadharBackVerification,
        aadharNumber: state.sentimentTracker.sentimentTrackerOnboarding.aadharNumber,
        isManualKYC: state.sentimentTracker.sentimentTrackerOnboarding.isManualKYC,
        loginProfile: state.customer.loginProfile,
        ...getKycCrossProductProps(state, config.productCodes.SENTIMENT),
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getOnboardingDataAction:sentimentTrackerOnboardingActions.getOnboardingData,
            updateSentimentTrackerOnboardingData:sentimentTrackerOnboardingActions.updateSentimentTrackerOnboardingData,
            setToast: commonActions.setToast,
        },
        dispatch
    );

const SentimentTrackerCkycStore = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);
export default SentimentTrackerCkycStore;
